import { takeEvery, put } from "redux-saga/effects";
import axios from "axios";
import {
  SEND_WELCOME_EMAILS,
  SEND_WELCOME_EMAILS_NEW_USERS
} from "../constants";
import apiCall from "../../utils/apiCall";

const emailActivateUsers = apiCall({
  type: SEND_WELCOME_EMAILS,
  method: "post",
  path: "/user/activate"
});

const emailReinviteUsers = apiCall({
  type: SEND_WELCOME_EMAILS_NEW_USERS,
  method: "post",
  path: "/user/reinvite"
});

export default function* welcomeEmailSaga() {
  yield takeEvery(SEND_WELCOME_EMAILS, emailActivateUsers);
  yield takeEvery(SEND_WELCOME_EMAILS_NEW_USERS, emailReinviteUsers);
}
